import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as UserInfoActions from '../../_actions/user-info.actions';
import { UserInfoState } from '../../_reducers/user-info.reducer';

@Component({
  selector: 'app-user-info',
  standalone: false,
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit, OnDestroy {
  @Input() public component: any;
  userInfoForm: FormGroup;
  showForm$: Observable<boolean>;
  error$: Observable<any>;
  isLoading = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private store: Store<{ userInfo: UserInfoState }>
  ) {
    this.showForm$ = this.store.select(state => !state.userInfo.submitted);
    this.error$ = this.store.select(state => state.userInfo.error);
  }

  ngOnInit() {
    this.userInfoForm = this.fb.group({
      firstName: [{value: '', disabled: false}, Validators.required],
      lastName: [{value: '', disabled: false}, Validators.required],
      email: [{value: '', disabled: false}, [Validators.required, Validators.email]]
    });

    // Subscribe to both success and error states
    this.subscriptions.push(
      this.showForm$.subscribe(submitted => {
        if (!submitted) {
          this.isLoading = false;
        }
      }),
      this.error$.subscribe(error => {
        if (error) {
          this.isLoading = false;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onSubmit() {
    if (this.userInfoForm.valid) {
      this.isLoading = true;
      // Clear any previous errors
      this.store.dispatch(UserInfoActions.submitUserInfo({
        formData: this.userInfoForm.value
      }));
    } else {
      this.userInfoForm.markAllAsTouched();
    }
  }
} 